import React, { useEffect, useState } from "react";
import { getComments } from "../app/API/profileAPI";
import { getProfileMedia } from "../app/API/commentAPI";
import Comment from "./Comment/Comment";
import PendingComment from "./PendingComment/PendingComment";
import LoadMoreButton from "./LoadMoreButton";
import { selectors as mediaSelectors, setMedia, setShowGallery } from "../app/slices/mediaSlice";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FsLightbox from "./FsLightbox/FsLightbox";

function ProfileCommentList(props) {
  const [skip, setSkip] = useState(0);
  const [comments, setComments] = useState([]);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(true);
  const [currentStatusId, setCurrentStatusId] = useState(0); 
  const [hasComments, setHasComments] = useState(null);

  const {
    top,
    id,
    statusId,
    isLoggedInUsersOwnProfile,
    loadingComplete,
    title,
    updateHasCommentType, 
    showGallery,
    media,
    setMedia
  } = props;

  useEffect(() => {
    (async () => {
      const response = await getComments(
        id,
        skip,
        top,
        statusId,
        false,
        false,
        false,
        false
      );   

      const status = document.getElementById("status");
      let statusOfDropdownItem = 2; 
      if(status !== null) {
        switch (status.value.toString()) {
          case "pending":
            statusOfDropdownItem = 1; 
            break;
          case "approved":
            statusOfDropdownItem = 2; 
            break;
          case "awaiting":
            statusOfDropdownItem = 5; 
            break;
        }
      }

      // if the status of the dropdown item is not the same as the status id
      // set comments to empty array and set loading complete to false
      if(statusOfDropdownItem == statusId) {
        const responseValues = response.value ?? []; 

        responseValues.length === 0 ? setHasComments(false) : setHasComments(true); 
        responseValues.length !== top ? setShowLoadMoreButton(false) : setShowLoadMoreButton(true); 
  
        if(statusId !== currentStatusId) {
          setComments([...responseValues]);
        } else {
          setComments((c) => [...c, ...responseValues]);
        }
  
        loadingComplete(true);
      }
    })();
  }, [id, skip, top, statusId]);

  useEffect(() => {
    if(statusId !== currentStatusId){
      loadingComplete(false);
      setComments([]);
      setCurrentStatusId(statusId);
      setSkip(0);
      setHasComments(null); 
    }
  }, [statusId]);

  useEffect(() => {
    // get media items
    (async function () {
      const response = await getProfileMedia(id, statusId);
      setMedia(response);
    })();
  }, [id, statusId, setMedia]);

  const heading = isLoggedInUsersOwnProfile ? `My ${title}` : `${title.charAt(0).toUpperCase()}${title.slice(1)}`;

  comments && comments.length > 0 && updateHasCommentType(statusId);

  if (comments && comments.length > 0) {
    return (
      <div className="ugc-profile-comments-list">

        <h3 className="sr-only ugc-profile-comments-list__count">
          {`${heading} (${comments.length})`}
        </h3>

        {
          comments.map((comment, i) => {
            return statusId === 1 ?
              <PendingComment
                profilePage
                comment={comment}
                item={comment.item}
                externalId={comment.externalId}
                key={i}/>
              :
              <Comment
                profilePage
                comment={comment}
                item={comment.item}
                externalId={comment.externalId}
                key={i}/>
              ;
          })
        }

        <div className="ugc-profile-comments-list__load-more">
          {
            showLoadMoreButton ?
              <LoadMoreButton
                top={top}
                skip={skip}
                setSkip={setSkip}
                classNames={'button-full-width-mobile'}/>
              :
              "There aren't any more comments"
          }
        </div>
        <FsLightbox
          showGallery={showGallery}
          media={media}
        />
      </div>
    );
  } else if(statusId !== 2) {
    return (
      <div>
        {hasComments !== null && !hasComments && (
          <>
            {isLoggedInUsersOwnProfile ?
              <p>You currently have no {title} </p> :
              <p>This person has no {title} </p>}
          </>
        )}
      </div>
    );
  } else {
    return null;
  }
}

ProfileCommentList.propTypes = {
  media: PropTypes.array,
  fetchMedia: PropTypes.func,
  setMedia: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    media: mediaSelectors.media(state),
    showGallery: mediaSelectors.showGallery(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMedia: (media) => dispatch(setMedia(media)),
    setShowGallery: (value) => dispatch(setShowGallery(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileCommentList);